/**
 * Tras un escaneo exitoso en POS (venta), hay que limpiar filtros.
 * Si el buscador se queda con el código (y/o la categoría del ítem), el próximo
 * disparo HID concatena o Enter reenvía basura, y la grilla queda filtrada —
 * el usuario solo recupera el flujo refrescando la pantalla.
 */
export type PosBarcodeScanFilterReset = {
  searchQuery: '';
  category: 'all';
};

export function posBarcodeScanFilterResetAfterHit(): PosBarcodeScanFilterReset {
  return { searchQuery: '', category: 'all' };
}
